"use strict";

exports.__esModule = true;
exports.default = void 0;

var _collapse = require("./collapse");

var _toggle = require("../../directives/toggle");

var _plugins = require("../../utils/plugins");

var components = {
  BCollapse: _collapse.default
};
var plugins = {
  BToggleDirectivePlugin: _toggle.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    components: components,
    plugins: plugins
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/collapse/index.js
// module id = yTKe
// module chunks = 14